import React, { useEffect, useState } from "react";
import { createPortal } from "react-dom";

const TopProgressBar = () => {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    // Add a class to the body to disable pointer events
    if (typeof document !== "undefined") {
      document.body.style.pointerEvents = "none";
    }

    const interval = setInterval(() => {
      setProgress(prevProgress => {
        if (prevProgress >= 90) {
          return prevProgress;
        }
        const increment = Math.random() * 10;
        return Math.min(prevProgress + increment, 90);
      });
    }, 200);

    return () => {
      clearInterval(interval);
      // Set progress to 100 briefly before unmounting
      setProgress(100);

      // Re-enable pointer events when component unmounts
      if (typeof document !== "undefined") {
        setTimeout(() => {
          document.body.style.pointerEvents = "";
        }, 300); // Small delay to ensure animation completes
      }
    };
  }, []);

  // Use createPortal to render at the top level of the document
  if (typeof document !== "undefined") {
    return createPortal(
      <>
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "3px",
            backgroundColor: "transparent",
            zIndex: 9999
          }}
        >
          <div
            style={{
              height: "100%",
              width: `${progress}%`,
              backgroundColor: "#1976d2",
              transition: "width 0.2s ease-in-out"
            }}
          />
        </div>
        {/* Full-page overlay to visually indicate that the page is loading */}
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            zIndex: 9998,
            cursor: "wait"
          }}
        />
      </>,
      document.body
    );
  }

  return null;
};

export default TopProgressBar;
